module.exports = __webpack_public_path__ + "static/assets/c6512c99c2c300e1ed16dfc63d514d17.png";